// reducers/employee-onboarding/index.js

import { combineReducers }           from 'redux';
import { responses }                 from './responses';
import { responsesHasErrored }       from './responses';
import { responsesIsLoading }        from './responses';
import { responsesAdd }              from './responses';
import { responsesAddHasErrored }    from './responses';
import { responsesAddIsLoading }     from './responses';
import { responsesDelete }           from './responses';
import { responsesDeleteHasErrored } from './responses';
import { responsesDeleteIsLoading }  from './responses';

import { tickets }                   from './tickets';
import { ticketsHasErrored }         from './tickets';
import { ticketsIsLoading }          from './tickets';

import { add }                       from './add';
import { addHasErrored }             from './add';
import { addIsLoading }              from './add';

import { skip }                      from './skip';
import { skipHasErrored }            from './skip';
import { skipIsLoading }             from './skip';

import { groups }                    from './groups';
import { groupsHasErrored }          from './groups';
import { groupsIsLoading }           from './groups';

import { reminder }                  from './reminder';
import { reminderHasErrored }        from './reminder';
import { reminderIsLoading }         from './reminder';

import { notify }                    from './notify';
import { notifyHasErrored }          from './notify';
import { notifyIsLoading }           from './notify';

import { remove }                    from './remove';
import { removeHasErrored }          from './remove';
import { removeIsLoading }           from './remove';
import { removeDisplay }             from './remove';
import { removeDisplayHasErrored }   from './remove';
import { removeDisplayIsLoading }    from './remove';

import { list }                      from './list';
import { listHasErrored }            from './list';
import { listIsLoading }             from './list';
import { listGroups }                from './list';
import { listGroupsHasErrored }      from './list';
import { listGroupsIsLoading }       from './list';

import { deny }                      from './deny';
import { denyHasErrored }            from './deny';
import { denyIsLoading }             from './deny';

import { approve }                   from './approve';
import { approveHasErrored }         from './approve';
import { approveIsLoading }          from './approve';
import { approveCheck }              from './approve';
import { approveCheckHasErrored }    from './approve';
import { approveCheckIsLoading }     from './approve';

import { receipt }                   from './receipt';
import { receiptHasErrored }         from './receipt';
import { receiptIsLoading }          from './receipt';

import { direct }                    from './direct';
import { directHasErrored }          from './direct';
import { directIsLoading }           from './direct';

const responsesReducers = combineReducers({
  responses,
  responsesHasErrored,
  responsesIsLoading,
  responsesAdd,
  responsesAddHasErrored,
  responsesAddIsLoading,
  responsesDelete,
  responsesDeleteHasErrored,
  responsesDeleteIsLoading
});

const ticketsReducers = combineReducers({
  tickets,
  ticketsHasErrored,
  ticketsIsLoading
});

const addReducers = combineReducers({
  add,
  addHasErrored,
  addIsLoading
});

const skipReducers = combineReducers({
  skip,
  skipHasErrored,
  skipIsLoading
});

const groupsReducers = combineReducers({
  groups,
  groupsHasErrored,
  groupsIsLoading
});

const reminderReducers = combineReducers({
  reminder,
  reminderHasErrored,
  reminderIsLoading
});

const notifyReducers = combineReducers({
  notify,
  notifyHasErrored,
  notifyIsLoading
});

const removeReducers = combineReducers({
  remove,
  removeHasErrored,
  removeIsLoading,
  removeDisplay,
  removeDisplayHasErrored,
  removeDisplayIsLoading
});

const listReducers = combineReducers({
  list,
  listHasErrored,
  listIsLoading,
  listGroups,
  listGroupsHasErrored,
  listGroupsIsLoading
});

const denyReducers = combineReducers({
  deny,
  denyHasErrored,
  denyIsLoading
});

const approveReducers = combineReducers({
  approve,
  approveHasErrored,
  approveIsLoading,
  approveCheck,
  approveCheckHasErrored,
  approveCheckIsLoading
});

const receiptReducers = combineReducers({
  receipt,
  receiptHasErrored,
  receiptIsLoading
});

const directReducers = combineReducers({
  direct,
  directHasErrored,
  directIsLoading
});

export default combineReducers({
  responses : responsesReducers,
  tickets   : ticketsReducers,
  add       : addReducers,
  skip      : skipReducers,
  groups    : groupsReducers,
  reminder  : reminderReducers,
  notify    : notifyReducers,
  remove    : removeReducers,
  list      : listReducers,
  deny      : denyReducers,
  approve   : approveReducers,
  receipt   : receiptReducers,
  direct    : directReducers
});